import {
  faCircle as faCircleRegular,
  faComment as faCommentRegular,
  faPenToSquare,
} from "@fortawesome/free-regular-svg-icons";
import {
  IconDefinition,
  faAnglesLeft,
  faAnglesRight,
  faArrowUpRightFromSquare,
  faArrowsRotate,
  faBackward,
  faBolt,
  faBoxArchive,
  faCalendar,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faCircleCheck,
  faCircleHalfStroke,
  faCircleInfo,
  faCircleQuestion,
  faCircleXmark,
  faDatabase,
  faDownload,
  faEye,
  faFileArrowUp,
  faFilePen,
  faFilter,
  faForward,
  faHourglassHalf,
  faLayerGroup,
  faList,
  faLock,
  faMagnifyingGlass,
  faPen,
  faPlus,
  faSliders,
  faTrashCan,
  faTriangleExclamation,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

export const ICONS: Record<string, IconDefinition> = {
  anglesLeft: faAnglesLeft,
  anglesRight: faAnglesRight,
  calendar: faCalendar,
  chevronDown: faChevronDown,
  chevronLeft: faChevronLeft,
  chevronRight: faChevronRight,
  circle: faCircle,
  circleCheck: faCircleCheck,
  circleHalfStroke: faCircleHalfStroke,
  circleInfo: faCircleInfo,
  circleRegular: faCircleRegular,
  circleXmark: faCircleXmark,
  comment: faCommentRegular,
  database: faDatabase,
  delete: faTrashCan,
  download: faDownload,
  eye: faEye,
  fileArrowUp: faFileArrowUp,
  filePen: faFilePen,
  filter: faFilter,
  forward: faForward,
  backward: faBackward,
  layerGroup: faLayerGroup,
  sliders: faSliders,
  triangleExclamation: faTriangleExclamation,
  circleQuestion: faCircleQuestion,
  previewNewTab: faArrowUpRightFromSquare,
  replace: faArrowsRotate,
  x: faXmark,
  add: faPlus,
  edit: faPen,
  draft: faPenToSquare,
  lock: faLock,
  search: faMagnifyingGlass,
  archive: faBoxArchive,
  hourGlassHalf: faHourglassHalf,
  automated: faBolt,
  list: faList,
} as const;
